import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VMS_Notification } from 'src/app/model/notification.model';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent implements OnInit {

  p: any=1;
  searchTerm: any;
  notificationList: VMS_Notification[] = [];

  constructor(private toastr: ToastrService, private notificationSer: NotificationService,private router: Router) { }

  ngOnInit() {
    this.GetAllNotifications();
  }
  ResetPage() {
    this.p = 1;
  }


  GetAllNotifications() {
    this.notificationSer.GetAllNotifications().subscribe(
      res => {
        console.log(res);
        this.notificationList = res.Data;
      },
      error => {
        console.log(error);
      }
    );
  }

  GoToEdit(id: number) {
    this.router.navigate(['/notification'], { queryParams: { id: id }, replaceUrl: true });
  }

  GoToView(id: number) {
    this.router.navigate(['/notification-details'], { queryParams: { id: id }, replaceUrl: true });
  }


}
